<script setup lang="ts">
import SVG from "@/stories/displays/SVG/SVG.vue";
import type { SVGName } from "@/SVGs";

interface Props {
  isActive?: boolean;
  iconSVG: SVGName;
}

defineProps<Props>();

defineEmits<{ click: [] }>();
</script>

<template>
  <button
    type="button"
    :class="[
      'p-2 rounded-lg w-12 h-12 transition-colors flex items-center justify-center',
      'hover:bg-neutral500-o20',
      'focus-visible-inverse',
      isActive ? 'bg-neutral500-o20' : '',
    ]"
    @click="$emit('click')"
  >
    <SVG :icon="iconSVG" height="1.5rem" width="1.5rem" />
  </button>
</template>
